const data = {
  "breadcrumbs": {
    "ariaLabel": "Broodkruimels"
  },
  "carousel": {
    "ariaLabelPrev": "Vorige",
    "ariaLabelNext": "Volgende"
  },
  "collapse": {
    "labelCollapsed": "Meer weergeven",
    "labelExpanded": "Minder weergeven"
  },
  "drawer": {
    "ariaLabelClose": "Sluiten"
  },
  "modal": {
    "ariaLabelClose": "Sluiten"
  },
  "pagination": {
    "ariaLabelPagination": "Paginering",
    "ariaLabelGoTo": "ga naar pagina {page}",
    "ariaLabelNext": "volgende pagina",
    "ariaLabelPrev": "vorige pagina",
    "labelNext": "Volgende",
    "labelPrev": "Vorige"
  },
  "passwordStrengthIndicator": {
    "labelStrengthIndicator": "Sterkte:",
    "description": "Tip: gebruik nummers, hoofdletters en woorden."
  },
  "popover": {
    "ariaLabelClose": "Sluiten"
  },
  "reviewRating": {
    "descriptiveLabelRating": "Beoordeling is {value} van de 10.",
    "descriptiveLabelReviewCountSingular": "Beoordeling is {value} van de 10, gebaseerd op {reviewCount} review.",
    "descriptiveLabelReviewCountPlural": "Beoordeling is {value} van de 10, gebaseerd op {reviewCount} reviews.",
    "labelFirstReview": "Schrijf de eerste review",
    "labelReviewSingular": "{value} review",
    "labelReviewPlural": "{value} reviews",
    "labelEmphasizedSingular": "Gebaseerd op {value} review",
    "labelEmphasizedPlural": "Gebaseerd op {value} reviews"
  },
  "tabs": {
    "ariaLabelPrev": "Vorige",
    "ariaLabelNext": "Volgende"
  },
  "map": {
    "ariaLabelZoomIn": "Inzoomen",
    "ariaLabelZoomOut": "Uitzoomen",
    "ariaLabelPanUp": "Kaart omhoog verplaatsen",
    "ariaLabelPanDown": "Kaart omlaag verplaatsen",
    "ariaLabelPanLeft": "Kaart naar links verplaatsen",
    "ariaLabelPanRight": "Kaart naar rechts verplaatsen",
    "ariaLabelShowPan": "Pijlbesturing tonen",
    "ariaLabelHidePan": "Pijlbesturing verbergen",
    "ariaLabelEnterFullscreen": "Volledig scherm openen",
    "ariaLabelExitFullscreen": "Volledig scherm afsluiten"
  },
  "autocomplete": {
    "labelNoOptions": "Geen opties om te selecteren",
    "labelSelectAll": "Alles selecteren",
    "labelChipsCollapsed": "{count} chips geselecteerd",
    "labelLoading": "Opties laden...",
    "ariaLabelOpenDropdown": "Openen",
    "ariaLabelCloseDropdown": "Sluiten",
    "ariaLabelRemoveChip": "Verwijder {chip}",
    "ariaLabelRemoveAllChips": "Verwijder alle geselecteerde chips"
  },
  "dropdown": {
    "labelSelectAll": "Alles selecteren",
    "labelMultiOptionsSelected": "{count} geselecteerd"
  },
  "numberStepInput": {
    "labelIncrement": "Waarde verhogen",
    "labelDecrement": "Waarde verlagen"
  }
};

export default data;